<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="(choice, index) in question.max"
            :key="index"
            :class="['choice', 'select-choice', 'auto', { selected: response != null && response[choice - 1] }]">
            <span class="text">
                {{ question.select[choice - 1] }}
            </span>
        </div>
    </div>
</template>

<script>

export default {   
    name: 'image-select-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Object,
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
